// extracted by mini-css-extract-plugin
var _1 = "DocFlowEditSequenceModalDraggableItem-moduledrag__FBUH8";
var _2 = "DocFlowEditSequenceModalDraggableItem-moduledragIcon__Mnpo7 IconNG-moduleiconContainer__SxWZ0";
export { _1 as "drag", _2 as "dragIcon" }
